import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideDefaultConfig } from '../config/config.module';
import { defaultAuthConfig } from './config/default-auth-config';
import { interceptors } from './http-interceptors/index';
import { AuthStoreModule } from './store/auth-store.module';

@NgModule({ imports: [CommonModule, AuthStoreModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [provideDefaultConfig(defaultAuthConfig), ...interceptors],
    };
  }
}
